import React, { useState, useEffect } from 'react';
import useCommonContent from '../hooks/useCommonContent';
import useLocale from '../hooks/useLocale';
import { getLocalizedPath } from '../data/i18nRoutes';

const COOKIE_KEY = 'tg_cookie_consent';

const CookieConsent = () => {
  const [visible, setVisible] = useState(false);
  const { t } = useCommonContent();
  const locale = useLocale();
  const cookiePath = getLocalizedPath('/politique-cookies', locale);

  useEffect(() => {
    if (!localStorage.getItem(COOKIE_KEY)) {
      const timer = setTimeout(() => setVisible(true), 1200);
      return () => clearTimeout(timer);
    }
  }, []);

  const accept = () => {
    localStorage.setItem(COOKIE_KEY, 'accepted');
    setVisible(false);
  };

  if (!visible) return null;

  return (
    <div
      style={{
        position: 'fixed',
        bottom: '24px',
        left: '24px',
        zIndex: 9999,
        maxWidth: '400px',
        background: '#ffffff',
        borderRadius: '16px',
        boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
        overflow: 'hidden',
        fontFamily: 'Inter, system-ui, sans-serif',
        animation: 'cookieSlideIn 0.4s ease-out',
      }}
    >
      <style>{`
        @keyframes cookieSlideIn {
          from { opacity: 0; transform: translateY(30px); }
          to   { opacity: 1; transform: translateY(0); }
        }
      `}</style>

      <div style={{ padding: '24px 24px 20px' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '12px' }}>
          <div style={{
            width: '36px',
            height: '36px',
            borderRadius: '50%',
            background: '#eff6ff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            flexShrink: 0,
          }}>
            <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#2563eb" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M12 22s8-4 8-10V5l-8-3-8 3v7c0 6 8 10 8 10z" />
              <path d="M9 12l2 2 4-4" />
            </svg>
          </div>
          <span style={{ fontWeight: 700, fontSize: '17px', color: '#0f172a' }}>
            {t('cookie.title')}
          </span>
        </div>

        <p style={{ fontSize: '14px', color: '#64748b', lineHeight: '1.7', margin: 0 }}>
          {t('cookie.body')}{' '}
          <a
            href={cookiePath}
            style={{ color: '#2563eb', textDecoration: 'underline', fontWeight: 500 }}
          >
            {t('cookie.policyLink')}
          </a>
        </p>
      </div>

      <button
        onClick={accept}
        style={{
          display: 'block',
          width: '100%',
          padding: '16px',
          background: '#2563eb',
          color: '#ffffff',
          border: 'none',
          borderRadius: 0,
          fontWeight: 700,
          fontSize: '16px',
          cursor: 'pointer',
          transition: 'background 0.2s',
          letterSpacing: '0.3px',
        }}
        onMouseOver={e => e.currentTarget.style.background = '#1d4ed8'}
        onMouseOut={e => e.currentTarget.style.background = '#2563eb'}
      >
        {t('cookie.accept')}
      </button>
    </div>
  );
};

export default CookieConsent;
